import { render, staticRenderFns } from "./PhoenixPricingTakeover.vue?vue&type=template&id=9380eaca"
import script from "./PhoenixPricingTakeover.vue?vue&type=script&lang=js"
export * from "./PhoenixPricingTakeover.vue?vue&type=script&lang=js"
import style0 from "./PhoenixPricingTakeover.vue?vue&type=style&index=0&id=9380eaca&prod&lang=scss&module=%24s"




function injectStyles (context) {
  
  this["$s"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports